import React, { useEffect, useState } from 'react'
import ContactUser from '../../assets/svg/contactIcon.svg'

const ContactView = ({ contact = {} }) => {
    const [contactData, setContactData] = useState({})

    useEffect(() => {
        setContactData(contact)
    }, [contact])

    return (
        <div className={`contact-view position-absolute top-100 bg-white shadow-lg rounded p-4 mt-1`} style={{ display: 'none', zIndex: 100 }}>
            <div className='d-flex gap-5 align-items-center'>
                <img className='item-image ms-0 ms-sm-3' src={ContactUser} />
                <div>
                    <h4 className='text-blue fw-bold'>Contact Info</h4>
                    <h4 className='text-blue fw-bold'>Name: <span className='fw-normal text-black position-relative top-0'> {contactData?.firstname ? (contactData?.firstname + (contactData?.lastname ? ' ' + contactData?.lastname : '')) : 'N/A'} </span></h4>
                    <h4 className='text-blue fw-bold'>Contact Id: <span className='fw-normal text-black position-relative top-0'> {contactData?.id || 'N/A'} </span></h4>
                    <h4 className='text-blue fw-bold'>Phone No: <span className='fw-normal text-black position-relative top-0'> {contactData?.phone || 'N/A'} </span></h4>
                    <h4 className='text-blue fw-bold'>Email: <span className='fw-normal text-black position-relative top-0'> {contactData?.email || 'N/A'} </span></h4>
                </div>
            </div>
        </div>
    )
}

export default ContactView